import { createFileRoute } from "@tanstack/react-router";

import ChallengePromotionForm from "@/components/ChallengeProfile/ChallengePromotionForm";

const Component = () => {
  const { challengeUuid } = Route.useParams();
  return <ChallengePromotionForm challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/profile/promotion")(
  {
    component: Component,
  },
);
